module.exports = __webpack_public_path__ + "static/media/codeyantra_logo.404f41f4.jpeg";